// extracted by mini-css-extract-plugin
export default {"transfers":"transfers_transfers__1Njy7"};